import React, { useMemo } from 'react';
import { Operation } from '../../hooks/useOperations/types';

import { importFromS3 } from '../../utils/importFromS3';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

type PluginProps = {
  operations: Operation[];
};

const DashboardPlugin: React.FC<PluginProps> = React.lazy(() => importFromS3('dashboard'));

export const DashboardPluginContainer = ({ operations }: PluginProps) => {
  const { operation: impersonatedOperation } = useImpersonatedOperation();
  const selectedOperations = useMemo(() => impersonatedOperation
    ? [impersonatedOperation]
    : [operations[1]],
  [impersonatedOperation, operations]);

  return <DashboardPlugin operations={selectedOperations} />;
};
